import React, { useState } from "react";
import classes from "./FileCard.module.css";
import MediaPDFIcon from "../../../../../assets/img/MediaPDFIcon.svg";
import MediaDOCIcon from "../../../../../assets/img/MediaDOCIcon.svg";
import MediaIMAGEIcon from "../../../../../assets/img/MediaIMAGEIcon.svg";
import { Button } from "@material-ui/core";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
const FileCard = (props) => {
  // State
  const [removeButton, setRemoveButton] = useState(true);
  // State Ends
  const removeAnswerFiles = () => {
    props.removeAnswerFiles(props.data.id);
  };
  const fileIconType = () => {
    switch (props.data.mimeType) {
      case "image/jpeg":
      case "image/png":
      case "image/svg+xml":
        return MediaIMAGEIcon;
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.template":
      case "application/vnd.ms-word.document.macroEnabled.12":
      case "application/vnd.ms-word.template.macroEnabled.12":
      case "text/plain":
        return MediaDOCIcon;
      case "application/pdf":
        return MediaPDFIcon;
      default:
        return MediaIMAGEIcon;
    }
  };
  const onViewFile = () => {
    props.viewFile(props.data);
  };
  return (
    <>
      <div
        className={classes.Card}
        // onMouseOver={() => {
        //   setRemoveButton(true);
        // }}
        // onMouseOut={() => {
        //   setRemoveButton(false);
        // }}
      >
        <img src={fileIconType()} className={classes.FileIcon} />
        <span className={classes.FileName}>{props.data.name}</span>
        {removeButton ? (
          <Button
            size="small"
            style={{ marginLeft: "10px", minWidth: "34px" }}
            onClick={onViewFile}
          >
            <span style={{ color: "#0074E4" }}>View</span>
          </Button>
        ) : (
          <div className={classes.FileRemoveButtonDummy}></div>
        )}
        {props.mode === "test" ? (
          <Button
            size="small"
            onClick={removeAnswerFiles}
            style={{
              marginLeft: "10px",
              minWidth: "32px",
            }}
          >
            <DeleteForeverIcon style={{ color: "#EB5757" }} fontSize="small" />
          </Button>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default FileCard;
